import { useEffect } from "react";
import { motion } from "framer-motion";
import Logo from "./Logo";
import { useLang } from "../i18n/i18n";

const LANGS = [
  { id: "fr", label: "Français" },
  { id: "en", label: "English" },
  { id: "es", label: "Español" },
];

export default function LangWelcome() {
  const { lang, setLang, showWelcome, closeWelcome } = useLang();

  useEffect(() => {
    if (!showWelcome) return;
    document.body.style.overflow = "hidden";
    window.__lenis?.stop();
    return () => {
      document.body.style.overflow = "";
      window.__lenis?.start();
    };
  }, [showWelcome]);

  if (!showWelcome) return null;

  const choose = (l) => {
    setLang(l);
    closeWelcome();
  };

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      className="fixed inset-0 z-[200] bg-ink/95 backdrop-blur-xl flex items-center justify-center p-4"
      data-testid="lang-welcome"
    >
      <div className="text-center max-w-md w-full">
        <motion.div
          initial={{ opacity: 0, y: 18 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.15, duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
          className="flex justify-center scale-125"
        >
          <Logo />
        </motion.div>
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.35, duration: 0.6 }}
          className="mt-8 text-xs tracking-[0.4em] uppercase text-mutedc"
        >
          Bienvenue · Welcome · Bienvenido
        </motion.p>
        <motion.h2
          initial={{ opacity: 0, y: 14 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.45, duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
          className="mt-4 font-display text-3xl sm:text-4xl font-light text-cream"
        >
          Choose your language
        </motion.h2>

        <div className="mt-9 space-y-3">
          {LANGS.map((l, i) => (
            <motion.button
              key={l.id}
              initial={{ opacity: 0, y: 16 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.6 + i * 0.12, duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
              onClick={() => choose(l.id)}
              data-testid={`lang-welcome-${l.id}`}
              className={`w-full rounded-xl border px-6 py-4 text-lg font-display transition-all ${
                lang === l.id
                  ? "border-gold bg-gold/15 text-goldlight"
                  : "border-gold/25 bg-panel/60 text-cream/85 hover:border-gold hover:bg-gold/10 hover:text-goldlight hover:shadow-[0_0_28px_rgba(212,175,55,0.25)]"
              }`}
            >
              {l.label}
            </motion.button>
          ))}
        </div>
      </div>
    </motion.div>
  );
}
